import { Badge as SectionTitleView } from '@silvertours/common-landingpages-view';
import { Ui } from '@silvertours/front-shared';

import { HasSectionTitleRules, HasSectionTitleSpacingRules } from './rule';

export type SectionTitleRules = HasSectionTitleRules &
  HasSectionTitleSpacingRules;

export type SectionTitleProps = {
  content?: SectionTitleView;
  rules: SectionTitleRules;
};

export const SectionTitle = ({
  content,
  rules: { sectionTitle: sectionTitleRules },
}: SectionTitleProps) => {
  const { shouldHide = false, style = 'default' } = sectionTitleRules || {};

  if (shouldHide) {
    return null;
  }

  return <Ui.SectionTitle text={content?.text} type={style} />;
};
